import React, { useEffect, useState } from "react"
import { Badge, Tab, Tabs } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import api from "../../api"
import { ConsolidationRequest, MultiDimsUpdateRequest } from "../../api/consolidation.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import ConfirmModal from "../../components/Common/ConfirmModal"
import { RootState } from "../../store"
import {
    loadConsolidated,
    loadConsolidations,
    multiBoxConsolidation,
    multiDimsUpdate,
    partialConsolidation,
    resetSuccess,
    setConsolBox
} from "../../store/consolidation.store"
import Header from "../Layout/Header"
import ConsolidateModal from "./ConsolidateModal"
import ConsolidationsTable from "./ConsolidationsTable"
import PostConsolidationModal from "./PostConsolidationModal"

const Consolidations = () => {
    //Date Picker Logic
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { consolidations, consolidated, loading, error, success, barcode, consolBox } = useAppSelector(
        (state: RootState) => state.consolidations
    )
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const [errors, setErrors] = useState({} as Record<string, any>)
    const [show, setShow] = useState("")
    const [selectedSuite, setSelectedSuite] = useState({} as Record<string, any>)
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    //useEffect(() => {
    //    const dateObj2 = {
    //        start_date: startDate
    //            ? moment(startDate).format("YYYY-MM-DD")
    //            : "2020-04-15",
    //        end_date: endDate
    //            ? moment(endDate).format("YYYY-MM-DD")
    //            : moment().add(1, "days").format("YYYY-MM-DD")
    //    }
    //}, [endDate])
    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    useEffect(() => {
        dispatch(
            loadConsolidations({
                warehouse: selectedWarehouse?.toString()
            })
        )
        dispatch(
            loadConsolidated({
                warehouse: selectedWarehouse?.toString()
            })
        )
    }, [selectedWarehouse])

    const consolidateBox = async (consolidationData: ConsolidationRequest) => {
        if (consolidationData?.consolidation_box_uuid) {
            await dispatch(multiBoxConsolidation(consolidationData))
        } else {
            await dispatch(partialConsolidation(consolidationData))
        }
    }

    const cancelConsolidation = async (consolBoxUuid: string) => {
        try {
            const res = await api.consolidation.cancelConsolidation(consolBoxUuid)

            if (res?.status) {
                setShow("")
                dispatch(
                    loadConsolidations({
                        warehouse: selectedWarehouse?.toString()
                    })
                )
                dispatch(
                    loadConsolidated({
                        warehouse: selectedWarehouse?.toString()
                    })
                )
            } else {
                setErrors({ ...errors, cancelError: res?.error || res?.message || "" })
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
        dispatch(setConsolBox({}))
    }

    const handleSubmit = async (multiDimsUpdateData: MultiDimsUpdateRequest) => {
        await dispatch(multiDimsUpdate(multiDimsUpdateData))
    }

    const afterReload = async () => {
        if (success) {
            dispatch(
                loadConsolidations({
                    warehouse: selectedWarehouse?.toString()
                })
            )
            dispatch(
                loadConsolidated({
                    warehouse: selectedWarehouse?.toString()
                })
            )
            dispatch(resetSuccess())

            if (show === "addWeightAndDims") {
                dispatch(setConsolBox({}))
                setShow("")
            } else {
                setShow("addWeightAndDims")
            }
            const barcodeLink = document.createElement("a") as HTMLAnchorElement
            barcodeLink.className = "d-none"
            barcodeLink.href = barcode || ""
            barcodeLink.target = "_blank"
            barcodeLink.click()
        }
    }

    useEffect(() => {
        afterReload()
    }, [success, selectedWarehouse])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="consolidation">
                    <Header
                        title="Consolidation"
                        records={Object.keys(consolidations)?.length + consolidated?.length}
                        data={consolidations}
                        name="consolidated"
                        //buttonId="#consolidationExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                            />*/}
                        </div>
                    </Header>

                    <div className="row  d-flex tabs-data px-2">
                        <Tabs defaultActiveKey="suites" id="suites-tab" className="mt-4">
                            <Tab
                                eventKey="suites"
                                title={
                                    <>
                                        {t("Consolidation Requests")}
                                        <Badge className="mx-2 px-2">
                                            {Object.keys(consolidations)?.length}
                                        </Badge>
                                    </>
                                }>
                                <ConsolidationsTable consolidations={consolidations} setShow={setShow} />
                            </Tab>
                            <Tab
                                eventKey="basic"
                                title={
                                    <>
                                        {t("Boxes")}
                                        <Badge className="mx-2 px-2">{consolidated?.length}</Badge>
                                    </>
                                }>
                                <ConsolidationsTable consolidations={consolidated} setShow={setShow} />
                            </Tab>
                        </Tabs>
                    </div>

                    {/*<div className="row  d-flex">
                        <ConsolidationsTable
                            consolidations={consolidations}
                            setShow={setShow}
                        />
                    </div>*/}

                    <ConsolidateModal show={show} setShow={setShow} consolidateBox={consolidateBox} />
                    <PostConsolidationModal
                        show={show}
                        setShow={setShow}
                        handleSubmit={handleSubmit}
                        errors={errors}
                        setErrors={setErrors}
                        warehouse={selectedWarehouse || defaultWarehouse}
                    />

                    <ConfirmModal
                        show={show}
                        data={consolBox?.uuid || {}}
                        handleClose={() => {
                            dispatch(setConsolBox({}))
                            setShow("")
                        }}
                        handleSubmit={cancelConsolidation}
                        title={"Cancel Consolidation Box"}
                    />
                </div>
            )}
        </>
    )
}

export default Consolidations
